export const filmOpenedLeft = '14.3%';
export const metadataLeft = '21.56%';
